import React, { useContext, useState } from 'react';

import { Dialog, Text, Heading, Box } from '@primer/components'
import ExitIntent from 'exit-intent'

import { useStore, getIsAuthenticated } from '../Store'
import Subscribe from './Subscribe'
import { useSubscribe } from '../hooks/useSubscribe'
import { useProduct } from '../hooks/useProduct'


export default function ExitModal(props) {
  const [defaultIsOpen, setIsOpen] = useState(false)
  const { state } = useStore()
  const isAuthenticated = getIsAuthenticated(state)

  React.useEffect(() => {
    const removeExitIntent = ExitIntent({
      threshold: 1,
      onExitIntent: () => {
        setIsOpen(true)
      },
    })
    return () => {
      removeExitIntent()
    }
  }, [])

  function handleDismiss(event) {
    setIsOpen(false)
    event.preventDefault()
  }

  const [isSubscribed, handleSubscribed] = useSubscribe()
  const isOpen = !isSubscribed && !isAuthenticated && defaultIsOpen
  const productDetails = useProduct()
  return (
    <Dialog className="p-2 text-center" isOpen={isOpen} onDismiss={handleDismiss}>
      <Box p={3}>
        <Heading>Stay up to date? Subscribe to our mailing list</Heading>
        <Text as="p" className="f3 mb-4">Occasional product updates and special offers. No spam, ever.</Text>
        <Subscribe
          handleSubscribed={handleSubscribed}
          isSubscribed={isSubscribed}
          isPrimary={true}
         />
         <Box as="p" className="mt-4 f3">
          <a href={productDetails.gitHubMarketplaceLink} target="_blank" rel="noopener noreferrer">GitHub</a>
          <span className={'ml-md-3 mr-md-3 ml-1 mr-1'}>·</span>
          <a href={productDetails.socialLinkDevDotTo} target="_blank" rel="noopener noreferrer">Dev.to</a>
          <span className={'ml-md-3 mr-md-3 ml-1 mr-1'}>·</span>
          <a href={productDetails.socialLinkTwitter} target="_blank" rel="noopener noreferrer">Twitter</a>
          <span className={'ml-md-3 mr-md-3 ml-1 mr-1'}>·</span>
          <a href={productDetails.socialLinkFacebook} target="_blank" rel="noopener noreferrer">Facebook</a>
          <span className={'ml-md-3 mr-md-3 ml-1 mr-1'}>·</span>
          <a href={productDetails.socialLinkLinkedIn} target="_blank" rel="noopener noreferrer">LinkedIn</a>
         </Box>
      </Box>
    </Dialog>
  )
}

